import { useMediaQuery } from "@mui/material";
import imgQualidadeAssegurada from "../../../../../assets/images/empresa/sobre-nos/SOBRE_NÓS_foco_na_qualidade_2.png";
import imgBannerSobreNos from "../../../../../assets/images/empresa/sobre-nos/SOBRE_NÓS_50_anos.png";
import DefaultButton from "../../../../../components/buttons/default-button";
import DefaultText from "../../../../../components/typography/default-text";
import Certifications from "./components/certifications";
import styles from "./styles.module.css";
import { useNavigate } from "react-router-dom";

const Historia: React.FC = () => {
  const navigate = useNavigate();
  const isDisplayMedium = useMediaQuery("(max-width: 1060px)");

  return (
    <>
      <div className={styles["sub-page-content"]}>
        <div className={styles["nossa-historia-banner-container"]}>
          <img
            src={imgBannerSobreNos}
            alt="Imagem de funcionário da Telemont subindo em uma escada"
            className={styles["nossa-historia-banner-image"]}
          />
          <div className={styles["nossa-historia-banner-text-content"]}>
            <DefaultText
              color="var(--primary-blue)"
              size={"medium"}
              sx={{
                fontFamily: "Montserrat-Bold",
                maxWidth: "600px",
                marginBottom: "16px",
              }}
            >
              <i>51 anos de história</i>
            </DefaultText>
            <DefaultText
              color="var(--primary-blue)"
              size={"small"}
              sx={{
                fontFamily: "Montserrat-Regular",
                fontSize: "20px",
                maxWidth: "600px",
                alignSelf: isDisplayMedium ? "unset" : "",
              }}
            >
              Há décadas, a Telemont conecta pessoas, negócios e oportunidades
              em todo o Brasil. Fundada em 1975, a empresa nasceu com o
              propósito de transformar vidas e impulsionar futuros, levando
              soluções em engenharia de telecomunicações e, ao longo do tempo,
              expandindo sua atuação também para o mercado de energia, com
              projetos que unem tecnologia, eficiência e sustentabilidade.
            </DefaultText>
            <DefaultText
              color="var(--primary-blue)"
              size={"small"}
              sx={{
                fontFamily: "Montserrat-Regular",
                fontSize: "20px",
                maxWidth: "530px",
                alignSelf: isDisplayMedium ? "unset" : "",
              }}
            >
              Atuando em 10 estados e no Distrito Federal, a Telemont é referência em infraestrutura,
              telecomunicações e energia, reconhecida pela
              excelência operacional, cultura de segurança e compromisso com o
              desenvolvimento sustentável.
            </DefaultText>
            <DefaultText
              color="var(--primary-blue)"
              size={"small"}
              sx={{
                fontFamily: "Montserrat-Regular",
                fontSize: "20px",
                maxWidth: "530px",
                alignSelf: isDisplayMedium ? "unset" : "",
              }}
            >
              Mais do que uma empresa de engenharia, a Telemont é um ecossistema
              de soluções integradas, que investe em inovação, desenvolvimento
              humano e responsabilidade social, gerando impacto positivo nas
              comunidades onde está presente e contribuindo para o avanço do
              país.
            </DefaultText>
            <DefaultText
              color="var(--primary-blue)"
              size={"small"}
              sx={{
                fontFamily: "Montserrat-Regular",
                fontSize: "20px",
                maxWidth: "530px",
                alignSelf: isDisplayMedium ? "unset" : "",
              }}
            >
              Com uma história sólida e um olhar voltado para o futuro, a
              Telemont segue fiel à sua essência transformadora: a de conectar
              para transformar.
            </DefaultText>
          </div>
        </div>
      </div>
      {/* <Slider /> */}
      <Certifications />
      <div className={styles["sub-page-content-grey"]}>
        <div className={styles["qualidade-assegurada-banner-container"]}>
          <div className={styles["banner-text-content"]}>
            <div>
              <DefaultText
                sx={{ fontFamily: "Montserrat-Regular", fontWeight: 600 }}
              >
                Foco no
              </DefaultText>
              <DefaultText sx={{ fontFamily: "Montserrat-Bold" }}>
                <i>bem-estar das pessoas!</i>
              </DefaultText>
            </div>
            <DefaultText
              size="small"
              maxWidth={
                useMediaQuery("(max-width: 1200px)") ? "unset" : "700px"
              }
            >
              Guiada pelas melhores práticas de gestão e por um{" "}
              <span className={styles["desktop-break"]}></span> compromisso
              genuíno com a responsabilidade{" "}
              <span className={styles["desktop-break"]}></span> socioambiental,
              a Telemont segue padrões rigorosos que{" "}
              <span className={styles["desktop-break"]}></span> asseguram
              eficiência, segurança e desenvolvimento{" "}
              <span className={styles["desktop-break"]}></span> contínuo.
            </DefaultText>
            <DefaultButton
              onClick={() => {
                navigate("/empresa/docs-politicas");
              }}
            >
              Saiba Mais
            </DefaultButton>
          </div>
          <img
            src={imgQualidadeAssegurada}
            alt={"Banner de operários sorrindo"}
            className={styles["qualidade-assegurada-banner-image"]}
          />
        </div>
      </div>
    </>
  );
};

export default Historia;
